import React from 'react';

class Youtube extends React.Component {
  static propTypes = {
    videoEmbedURL:   React.PropTypes.string.isRequired,
    alt:             React.PropTypes.string,
    controls:        React.PropTypes.bool,
    allowFullScreen: React.PropTypes.bool,
  }

  state = {
    loaded: false,
  }

  handleClick = (e) => {
    e.preventDefault();

    this.setState({ loaded: true });
  }

  thumbnailURL() {
    const urlParser = document.createElement("a");
    urlParser.href = this.props.videoEmbedURL;
    const videoID = urlParser.pathname.replace("/embed/", "");

    return `https://i.ytimg.com/vi/${videoID}/hqdefault.jpg`;
  }

  embedURL() {
    const urlParser = document.createElement("a");
    urlParser.href = this.props.videoEmbedURL;
    urlParser.search = "?autoplay=1&autohide=1&rel=0&showinfo=0"; // for embedding
    urlParser.search += this.props.controls ? "&controls=1" : "&controls=0";
    return urlParser.href;
  }

  render() {
    const notLoaded = (
      <div className="video-placeholder embed-responsive-item"
           style={{ backgroundImage: `url(${this.thumbnailURL()})` }}
           title={this.props.alt}
           onClick={this.handleClick}>
        <div className="play"></div>
      </div>
    );
    const loaded = (
      <iframe frameBorder="0" src={this.embedURL()} allowFullScreen={this.props.allowFullScreen}></iframe>
    );
    return (
      <div className="embed-responsive embed-responsive-16by9">
        { this.state.loaded ? loaded : notLoaded }
      </div>
    );
  }
}

export default Youtube;



// WEBPACK FOOTER //
// ./app/javascript/components/application/Youtube.jsx